interface CommentItem {
  name: string;
  time: string;
  content: string;
  avatar: string;
}

const comments: CommentItem[] = [
  {
    name: '追剧达人小李',
    time: '2024-07-30',
    content: '桔子视频真的是我最近发现的宝藏网站！西瓜视频和丝瓜视频的剧都能在这里看到，而且真的不缓冲，画质也很清晰。追庆余年第三季就是在这里看完的，强烈推荐给身边所有朋友！',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20avatar%20portrait%20with%20friendly%20smile%2C%20warm%20lighting%2C%20clean%20background%2C%20casual%20style%2C%20natural%20look%2C%20modern%20portrait&width=100&height=100&seq=juzi-avatar-01&orientation=squarish',
  },
  {
    name: '爱看剧的小王',
    time: '2024-07-28',
    content: '之前找丝瓜视频的资源总是很麻烦，没想到桔子视频直接聚合了。更新速度真的快，剧集上线当天就能看。高清全集免费这个真的太良心了，希望一直运营下去！',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20avatar%20portrait%20with%20warm%20smile%2C%20soft%20lighting%2C%20simple%20background%2C%20natural%20appearance%2C%20modern%20casual%20look%2C%20friendly%20expression&width=100&height=100&seq=juzi-avatar-02&orientation=squarish',
  },
  {
    name: '纪录片爱好者老张',
    time: '2024-07-25',
    content: '作为一个纪录片迷，桔子视频的纪录片专区让我惊喜！画质超棒，分类也很清晰。最重要的是完全免费，不用注册就能看。工作之余看看地球脉动放松一下，体验非常好。',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20avatar%20portrait%20with%20gentle%20smile%2C%20warm%20lighting%2C%20clean%20background%2C%20professional%20casual%20style%2C%20natural%20expression%2C%20friendly%20look&width=100&height=100&seq=juzi-avatar-03&orientation=squarish',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full uppercase tracking-wide">
            用户评价
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950">观众都在夸 · 真实观影反馈</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            听听桔子视频用户们的真实声音。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment) => (
            <div key={comment.name} className="bg-background-100 rounded-xl p-6 border border-background-200/60">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <div className="text-sm font-bold text-foreground-950">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              <div className="mt-4 flex items-center gap-1">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-secondary-400 text-sm"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}